import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="passwords"
export default class extends Controller {
  static targets = [
    "uppercaseMessage",
    "lowercaseMessage",
    "charactersMessage",
    "numberMessage",
    "lengthMessage",
    "confirmMessage",
    "passwordField",
    "button",
  ];

  connect() {}

  setPwOk(valid, element) {
    if (valid) {
      element.style.color = "#28a855";
      element.dataset.valid = "true";
    } else {
      element.style.color = "#a82838";
      element.dataset.valid = "false";
    }
  }

  validatePassword(event) {
    const password = event.target.value;

    this.setPwOk(password.match(/((?=.*[A-Z]).{1,})/), this.uppercaseMessageTarget);
    this.setPwOk(password.match(/((?=.*[a-z]).{1,})/), this.lowercaseMessageTarget);
    this.setPwOk(password.match(/((?=.*\W).{1,})/), this.charactersMessageTarget);
    this.setPwOk(password.match(/((?=.*[0-9]).{1,})/), this.numberMessageTarget);
    this.setPwOk(password.match(/.{12,}/), this.lengthMessageTarget);
    this.toggleButtonEnabled(this.allTargetsGreen());
  }

  validatePasswordConfirm(event) {
    const passwordConfirm = event.target.value;
    this.setPwOk(this.passwordFieldTarget.value === passwordConfirm, this.confirmMessageTarget);
    this.toggleButtonEnabled(this.allTargetsGreen());
  }

  allTargetsGreen() {
    const allValid =
      this.uppercaseMessageTarget.dataset.valid === "true" &&
      this.lowercaseMessageTarget.dataset.valid === "true" &&
      this.charactersMessageTarget.dataset.valid === "true" &&
      this.numberMessageTarget.dataset.valid === "true" &&
      this.lengthMessageTarget.dataset.valid === "true" &&
      this.confirmMessageTarget.dataset.valid === "true";
    return allValid;
  }

  toggleButtonEnabled(enableButton) {
    if (enableButton) this.buttonTarget.removeAttribute("disabled");
    else this.buttonTarget.setAttribute("disabled", "disabled");
  }
}
